export const colors = {
    primary: '#D4002A',
    navy: '#002058',
    lightGray: '#E1DED9',
    darkGray: '#65615D'
}